const openExternal = (url) => {
    if (!url) {
        return;
    }
    const href = String(url).trim();
    if (!href) {
        return;
    }

    const externalOpener = window?.electron?.openExternal
        || window?.api?.openExternal
        || window?.electronAPI?.openExternal;

    if (externalOpener) {
        try {
            externalOpener(href);
            return;
        } catch (error) {
            // Fall back to other handlers.
        }
    }

    if (window?.require) {
        try {
            const electron = window.require('electron');
            if (electron?.shell?.openExternal) {
                electron.shell.openExternal(href);
                return;
            }
        } catch (error) {
            // Ignore and fall back to browser open.
        }
    }

    window.open(href, '_blank', 'noopener,noreferrer');
};

export default { openExternal };
